import { z } from "zod";

export const newAssetSchema = z.object({
  files: z.instanceof(File).array().min(1),
  config_id: z.string().min(1),
  workspace_id: z.string().min(1),
  name: z
    .string()
    .optional()
    .transform((name) => name ?? undefined),
});

export type NewAssetForm = z.infer<typeof newAssetSchema>;
